<template>
<div>
 
    <va-card>
        <p class="display-3 text-center ">  {{get_dados_disciplina.nome_curso}}</p>
        <hr>

      <div class="row ">
          
   <div class="flex xs12 md12 lg3 bnt">
       <va-button type="submit" @click="inscricao()"  color="info" class="bnt">
           
            {{$t('arealuno.Inscrevase')}}
       </va-button>
    </div>     

    <div class="flex xs12 md12 lg8 va-card row">

        <div class=" flex xs12 md12 lg4 sm12 pad">
           <i class="va-icon glyphicon glyphicon-exclamation-sign" style="font-size: 30px;"></i>
           <div class="spa  ">
                *Pagos 
                <br>
                {{get_dados_disciplina.info_pagamento}}
            </div>
           
        </div>
        <div class="flex xs12 md12 lg4 sm12 pad">
            <i class="va-icon vuestic-iconset vuestic-iconset-time" style="font-size: 30px;"></i>
            <div class="spa  ">
                Periodo 
                <br>
                {{get_dados_disciplina.info_periodo}}
            </div>
        </div>

         <div class=" flex xs12 md12 lg3 sm12 text-center ">
          
                <img class="tamanho" src="../imgs/tarjetas-bancard.png" >
        
        </div>
    </div>        

  </div>

    <br>

    <div class="row">

      <div class=" flex xs12 md12 lg12 sm12 text-center">
          <iframe width="560" height="315" :src='get_dados_disciplina.url_video'
          frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>

    
        <div class="xs12 md12 lg12 sm12 flex scrollable">
        <va-card :title="this.$t('arealuno.Informacoes')">

          <va-accordion v-if="this.$t('arealuno.Idioma') == 'es'">


            <va-collapse customHeader>
              <span slot="header">
                <div class="grid__container flex-center"  style="background: linear-gradient(to right, rgb(64, 109, 125), rgb(49, 69, 89)); width: 100%;">{{$t('arealuno.Gradecurricular')}}</div>
              </span>
              <div slot="body">
               
                <div  class="flex  xs12 md12 lg12 sm12">

                  
          
                         <img class="tamanhomalla" :src="get_dados_disciplina.link_grade" >
                <!-- http://api.ucpvirtual.com.br/storage/carrossel/.jpg -->
        
                 

                  <!-- <table style="width: 100%;" class="va-table va-table--striped va-table--hoverable ">
                    
                    <tbody>

                      <tr v-for="(lista,index) in get_disciplinas" :key="index">
                        <td >{{lista.nome_disciplina}}</td>
                      </tr>
                      
                      </tbody>
                  </table> -->
                
                </div>
              </div>
            </va-collapse>  

            <va-collapse customHeader>
              <span slot="header">  
                 <div class="grid__container flex-center"  style="background: linear-gradient(to right, rgb(64, 109, 125), rgb(49, 69, 89)); width: 100%;">{{$t('arealuno.Justificativa')}}</div>
              </span>
              <div slot="body">
                
                <div>
                  {{get_dados_disciplina.info_justificativa}}
                 
                </div>
              </div>
            </va-collapse>
            <va-collapse customHeader>
              <span slot="header">  
                <div class="grid__container flex-center"  style="background: linear-gradient(to right, rgb(64, 109, 125), rgb(49, 69, 89)); width: 100%;">Objetivo</div>
              </span>
              <div slot="body">
                
                <div>
                 {{get_dados_disciplina.info_objetivo}}
                </div>
              </div>
            </va-collapse>
            <va-collapse customHeader>
              <span slot="header">
                <div class="grid__container flex-center"  style="background: linear-gradient(to right, rgb(64, 109, 125), rgb(49, 69, 89)); width: 100%;">{{$t('arealuno.Diri_prof_grado')}}</div>
              </span>
              <div slot="body">
               
                <div>
                 {{get_dados_disciplina.info_publico}}
                </div>
              </div>
            </va-collapse> 

              


          </va-accordion>


          <va-accordion v-if="this.$t('arealuno.Idioma') == 'pt'">


             <va-collapse customHeader>
              <span slot="header">
                <div class="grid__container flex-center"  style="background: linear-gradient(to right, rgb(64, 109, 125), rgb(49, 69, 89)); width: 100%;">{{$t('arealuno.Gradecurricular')}}</div>
              </span>
              <div slot="body">
               
                <div  class="flex  xs12 md12 lg12 sm12">

                  <img class="tamanhomalla" :src="get_dados_disciplina.link_grade_pt" >

                  <!-- <table style="width: 100%;" class="va-table va-table--striped va-table--hoverable ">
                   
                    <tbody>

                      <tr v-for="(lista,index) in get_disciplinas" :key="index">
                        <td >{{lista.nome_disciplina}}</td>
                      </tr>
                      
                      </tbody>
                  </table> -->
                
                </div>
              </div>
            </va-collapse>  


            <va-collapse customHeader>
              <span slot="header">  
                 <div class="grid__container flex-center"  style="background: linear-gradient(to right, rgb(64, 109, 125), rgb(49, 69, 89)); width: 100%;">Justificativa</div>
              </span>
              <div slot="body">
                
                <div>
                  {{get_dados_disciplina.info_justificativa_pt}}
                 
                </div>
              </div>
            </va-collapse>

            <va-collapse customHeader>
              <span slot="header">  
                <div class="grid__container flex-center"  style="background: linear-gradient(to right, rgb(64, 109, 125), rgb(49, 69, 89)); width: 100%;">Objetivo</div>
              </span>
              <div slot="body">
                
                <div>
                 {{get_dados_disciplina.info_objetivo_pt}}
                </div>
              </div>
            </va-collapse>
            <va-collapse customHeader>
              <span slot="header">
                <div class="grid__container flex-center"  style="background: linear-gradient(to right, rgb(64, 109, 125), rgb(49, 69, 89)); width: 100%;">Publico</div>
              </span>
              <div slot="body">
               
                <div>
                 {{get_dados_disciplina.info_publico_pt}}
                </div>
              </div>
            </va-collapse> 


             


          </va-accordion>
        </va-card>
      </div>
    </div>

</va-card>


</div>

      
 
</template>

<script>

export default {
  name: 'informacoes',
  
  data () {
      return {
        dados_disciplina:'',
      
      }
    },
 
  computed:{


      get_dados_disciplina(){
        let resultado = this.$store.state.informacao.infoGrade 
        
        return resultado
      },
      get_disciplinas(){
        let resultado = this.$store.state.informacao.disciplinaGrade 
        
        return resultado
      },
    },
  methods:{
    inscricao(){
       this.$router.push({ name: 'inscricao/formulario' })
    }
  
    }
}  
</script>

<style lang="scss" scoped>

.tamanhomalla {
   width: 100%;
   height: 100%;
   text-align: center;
}

.tamanho {
   width: 80%;
   height: 80%;
}
.spa {
    text-align: center;
    margin: -40px 0 0 0;
    font-size: 16px;
}
.bnt {
    margin: auto;
    width: 100%;
}
.pad {
    padding: 5px 0 5px 10px;
}
.scrollable {
  height: 550px;
  overflow-y: scroll;
}
.scroll {
//   height: 240px;
  max-height: 240px;
  overflow-y: scroll;
}
</style>
